import React from "react";

const PPVDemo2 = () => {
  return (
    <div className="w-full min-h-screen p-4 md:p-8">
      <div className="max-w-7xl mx-auto py-36">
        <iframe
          src="https://player.castr.com/live_7c816a503b1a11f08bef6379935bb298"
          className="w-full h-full"
          style={{
            aspectRatio: "16/9",
            minHeight: "calc(100vh - 200px)",
            maxHeight: "calc(100vh - 100px)",
          }}
          frameBorder="0"
          scrolling="no"
          allow="autoplay"
          allowFullScreen
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          oallowfullscreen="true"
          msallowfullscreen="true"
        ></iframe>
      </div>
    </div>
  );
};

export default PPVDemo2;
